import { TranslationKeys } from './en';

export const ru: TranslationKeys = {
  // Навигация
  nav: {
    home: "Главная",
    shop: "Магазин",
    lighting: "Освещение",
    electricity: "Электрика",
    hardware: "Фурнитура",
    accessories: "Аксессуары",
    cart: "Корзина",
    search: "Поиск",
    menu: "Меню",
    sale: "Распродажа",
    allCategories: "Все категории",
  },
  
  // Категории
  categories: {
    lighting: "Освещение",
    electricity: "Электрика",
    hardware: "Фурнитура",
    accessories: "Аксессуары",
    kitchens: "Кухни",
    // Подкатегории освещения
    chandeliers: "Люстры",
    ceilingLights: "Потолочные светильники",
    wallLights: "Настенные светильники",
    outdoorLighting: "Уличное освещение",
    lightBulbs: "Лампочки",
    // Подкатегории электрики
    lightSwitches: "Выключатели",
    dimmerSwitches: "Диммеры",
    plugSockets: "Розетки",
    backBoxes: "Монтажные коробки",
    plates: "Панели",
    modules: "Модули",
    otherSwitches: "Другие выключатели",
    toggleSwitches: "Тумблеры",
    rockerSwitches: "Клавишные",
    ukProducts: "UK товары",
    doorHandle: "Дверные ручки",
    fixedDoorHandle: "Фиксированные ручки",
    doorKnob: "Дверные ручки-кнобы",
    fixedDoorKnob: "Фиксированные кнобы",
    doorHinge: "Дверные петли",
    doorStop: "Дверные упоры",
    closetBar: "Штанга для гардероба",
    deadboltLatch: "Засов",
    mirror: "Зеркало",
    spares: "Запчасти",
    // Подкатегории аксессуаров
    jewellery: "Украшения",
    pets: "Для питомцев",
    machined: "Механические",
    // Подкатегории кухни
    cookware: "Посуда",
    mixerFaucets: "Кухонные смесители",
    kitchenFaucets: "Кухонные краны",
    kitchenShelves: "Кухонные полки",
    kitchenGirderShelf: "Балочная полка",
    kitchenHangerShelf: "Подвесная полка",
    fryingPans: "Сковородки",
    pots: "Кастрюли",
    // Типы продуктов Deante - Кухня
    sinks: "Мойки",
    graniteSinks: "Гранитные мойки",
    steelSinks: "Стальные мойки",
    ceramicSinks: "Керамические мойки",
    soapDispensers: "Дозаторы мыла",
    drainers: "Сушилки",
    baskets: "Корзины",
    cuttingBoards: "Разделочные доски",
    kitchenAccessories: "Кухонные аксессуары",
    // Типы продуктов Deante - Ванная
    bathroomFaucets: "Смесители для ванной",
    basinFaucets: "Смесители для раковины",
    bathFaucets: "Смесители для ванны",
    showerFaucets: "Смесители для душа",
    bidetFaucets: "Смесители для биде",
    concealedFaucets: "Встраиваемые смесители",
    showerSystems: "Душевые системы",
    showerColumns: "Душевые стойки",
    showerHeads: "Душевые лейки",
    handShowers: "Ручные лейки",
    showerTrays: "Душевые поддоны",
    showerEnclosures: "Душевые кабины",
    showerDrains: "Душевые трапы",
    basins: "Раковины",
    toilets: "Унитазы",
    toiletSeats: "Сиденья для унитаза",
    toiletPaperHolders: "Держатели туалетной бумаги",
    toiletFrames: "Инсталляции",
    wcFlushButtons: "Кнопки смыва",
    bidets: "Биде",
    bathroomAccessories: "Аксессуары для ванной",
    towelRails: "Полотенцедержатели",
    soapDishes: "Мыльницы",
    tumblers: "Стаканы",
    toiletBrushes: "Ершики",
    dispensers: "Дозаторы",
    mirrors: "Зеркала",
    bathroomShelves: "Полки для ванной",
    bathroomFurniture: "Мебель для ванной",
    bathroomCabinets: "Шкафы для ванной",
    vanityUnits: "Тумбы под раковину",
    kitchen: "Кухня",
    bathroom: "Ванная",
    pendants: "Подвесы",
    tableLamps: "Настольные лампы",
    floorLamps: "Напольные лампы",
    spotLights: "Точечные светильники",
    keyrings: "Брелки",
    gifts: "Подарки",
    // Дополнительные подкатегории Deante
    bathtubs: "Ванны",
    freestandingBath: "Отдельностоящие ванны",
    builtInBath: "Встраиваемые ванны",
    bathSpouts: "Изливы для ванны",
    showerRails: "Душевые штанги",
    basinWaste: "Сифоны для раковины",
    showerWaste: "Сифоны для душа",
    radiatorValves: "Радиаторные клапаны",
    rails: "Рейлинги",
  },

  // Hero секция
  hero: {
    title: "Где",
    titleAccent: "Дизайн",
    titleEnd: "Становится Искусством",
    subtitle: "Эксклюзивная коллекция премиальной архитектурной фурнитуры, освещения, кухонных решений и интерьерных деталей. Для тех, кто верит, что каждая деталь должна быть шедевром.",
    shopCollection: "Смотреть Коллекцию",
    exploreRange: "Изучить Ассортимент",
  },

  // Продукт
  product: {
    addToCart: "Добавить в корзину",
    outOfStock: "Нет в наличии",
    quantity: "Количество",
    sku: "Артикул",
    price: "Цена",
    finish: "Отделка",
    size: "Размер",
    logo: "Логотип",
    knurl: "Накатка",
    viewDetails: "Подробнее",
    viewAll: "Смотреть все",
    noProducts: "Товары не найдены",
    noProductsDesc: "Попробуйте изменить фильтры или просмотреть все товары.",
    clearFilters: "Очистить фильтры",
    featuredProducts: "Рекомендуемые товары",
    shopFullCollection: "Смотреть всю коллекцию",
  },

  // Страница магазина
  shop: {
    title: "Все товары",
    subtitle: "Изучите нашу полную коллекцию премиальной архитектурной фурнитуры, освещения и электрики.",
    collection: "Коллекция",
    category: "Категория",
    allCategories: "Все категории",
    productType: "Тип товара",
    allTypes: "Все типы",
    collectionFilter: "Коллекция",
    allCollections: "Все коллекции",
    brand: "Бренд",
    allBrands: "Все бренды",
    sortBy: "Сортировать",
    default: "По умолчанию",
    priceLowHigh: "Цена: по возрастанию",
    priceHighLow: "Цена: по убыванию",
    nameAZ: "Название: А-Я",
    nameZA: "Название: Я-А",
    show: "Показать",
    items: "",
    clearAll: "Очистить все",
    products: "товаров",
    product: "товар",
    loading: "Загрузка...",
    previous: "Назад",
    next: "Вперед",
    hideUKProducts: "Скрыть UK товары",
    searchPlaceholder: "Поиск товаров...",
    noProducts: "Товары не найдены",
    loadAllProducts: "Загрузить все товары",
    loadingAll: "Загрузка всех...",
    price: "Цена",
    priceRange: "Диапазон цен",
  },

  // Детали продукта
  productDetail: {
    home: "Главная",
    products: "Товары",
    fastShipping: "Быстрая доставка",
    warranty: "Гарантия",
    returns: "Возврат 30 дней",
    lifestyle: "Стиль жизни",
    details: "Детали",
    whatsInBox: "В комплекте",
    specifications: "Характеристики",
    dimensions: "Размеры",
    electrical: "Электрические",
    lightingSpecs: "Освещение",
    hardwareSpecs: "Фурнитура",
    documents: "Документы",
    lineDrawing: "Чертёж",
    specSheet: "Спецификация",
    instructionManual: "Инструкция",
    download: "Скачать",
    noImage: "Нет изображения",
    productNotFound: "Товар не найден",
    backToStore: "Назад в магазин",
    imageDisclaimer: "Изображение носит иллюстративный характер и товар может отличаться от показанного.",
    components: "Компоненты",
    componentsDesc: "Этот товар состоит из:",
    // Секция размеров упаковки
    packageDimensions: "Размеры упаковки",
    productDimensions: "Размеры товара",
    width: "Ширина",
    height: "Высота",
    length: "Длина",
    weight: "Вес",
    minWidth: "Мин. ширина",
    minHeight: "Мин. высота",
    // Метки характеристик
    packageWidth: "Ширина упаковки",
    packageHeight: "Высота упаковки",
    packageLength: "Длина упаковки",
    packageWeight: "Вес упаковки",
    itemWeight: "Вес товара",
    minLength: "Длина",
    internalDepth: "Внутренняя глубина",
    externalDepth: "Внешняя глубина",
    projection: "Выступ",
    voltage: "Напряжение",
    amperage: "Ампераж",
    frequency: "Частота",
    ipRating: "Класс IP",
    ceGrade: "Класс CE",
    numBulbs: "Количество ламп",
    bulbBase: "Цоколь",
    bulbType: "Тип лампы",
    maxWattage: "Макс. мощность",
    lumen: "Световой поток",
    dimmable: "Диммируемый",
    kelvin: "Цветовая температура",
    cri: "CRI",
    lifeHours: "Срок службы",
    cordLength: "Длина шнура",
    distanceBetweenHoles: "Межосевое расстояние",
    roseDiameter: "Диаметр розетки",
    barDiameter: "Диаметр стержня",
    spindleDimension: "Размер шпинделя",
    plateMaterial: "Материал панели",
    switchType: "Тип выключателя",
  },

  // Корзина
  cart: {
    title: "Корзина",
    empty: "Ваша корзина пуста",
    emptyDesc: "Добавьте товары, чтобы начать",
    continueShopping: "Продолжить покупки",
    subtotal: "Итого",
    subtotalExVat: "Итого (без НДС)",
    vatAmount: "НДС (21%)",
    checkout: "Оформить заказ",
    remove: "Удалить",
    addedToCart: "Добавлено в корзину",
    viewCart: "Смотреть корзину",
    // Business customer cart
    businessCheckout: "Заказать по счёту",
    shopifyCheckout: "Оплатить сейчас",
    yourDiscount: "Ваша скидка",
    vatIncluded: "НДС (21%) включён в цену",
    orderPlaced: "Заказ успешно оформлен",
    orderPlacedDesc: "Счёт будет отправлен на вашу почту",
    paymentTerms: "Срок оплаты",
    days: "дней",
    total: "Итого",
    // Shipping & Delivery
    shippingCountry: "Страна доставки",
    selectCountry: "Выберите страну",
    shipping: "Доставка",
    freeShipping: "Бесплатно",
    freeShippingFrom: "Бесплатная доставка от",
    calculatedAtCheckout: "Рассчитывается при оформлении",
    shippingNote: "Выберите способ доставки при оформлении",
    selectCountryForShipping: "Выберите страну",
    secureCheckout: "Безопасная оплата через Shopify",
    agreeToTerms: "Я согласен с",
    purchaseTermsLink: "Условиями покупки",
    deliveryAddress: "Адрес доставки",
    deliveryMethod: "Способ доставки",
    pickupInStore: "Самовывоз из магазина",
    free: "БЕСПЛАТНО",
    deliveryToAddress: "Доставка по адресу",
    deliveryPriceNote: "Стоимость доставки зависит от веса и страны",
    savedAddress: "Сохранённый адрес",
    newAddress: "Другой адрес",
    address: "Адрес",
    fillDeliveryAddress: "Пожалуйста, заполните все поля адреса доставки",
    back: "Назад",
    backToCart: "Назад в корзину",
    proceedToDelivery: "Перейти к доставке",
    createInvoice: "Создать счёт",
    confirmOrder: "Подтвердить заказ",
    invoiceWillBeSent: "Счёт будет отправлен на вашу почту",
    country: "Страна",
    city: "Город",
    postalCode: "Индекс",
    streetAddress: "Улица, дом",
    storePickup: "Самовывоз из магазина",
    // Omniva
    parcelLocker: "Постамат",
    selectParcelLocker: "Выбрать постамат",
    searchTerminals: "Поиск по городу или адресу...",
    loadingTerminals: "Загрузка постаматов...",
    noTerminalsFound: "Постаматы не найдены",
    terminalsAvailable: "постаматов доступно",
    omnivaDelivery: "Постамат Omniva",
    omnivaNote: "Удобное получение 24/7",
    courierDelivery: "Курьерская доставка",
    courierNote: "Доставка по адресу",
    selectDeliveryMethod: "Выберите способ доставки",
    orderNotes: "Примечания к заказу",
    orderNotesPlaceholder: "Добавьте специальные инструкции или примечания к заказу...",
    promoPlaceholder: "Промокод",
    applyPromo: "Применить",
    promoApplied: "Промокод применён!",
    promoInvalid: "Недействительный промокод",
    promoRemoved: "Промокод удалён",
    promoNotAvailableWithSale: "Промокоды недоступны для товаров со скидкой",
  },

  // Бизнес
  business: {
    login: "Вход для бизнеса",
    register: "Регистрация бизнеса",
    companyName: "Название компании",
    registrationNumber: "Регистрационный номер",
    vatNumber: "Номер НДС",
    contactName: "Контактное лицо",
    phone: "Телефон",
    billingAddress: "Адрес для счетов",
    city: "Город",
    postalCode: "Индекс",
    country: "Страна",
    alreadyHaveAccount: "Уже есть аккаунт?",
    noAccount: "Нет аккаунта?",
    registerHere: "Зарегистрироваться",
    loginHere: "Войти",
    awaitingApproval: "Ожидание подтверждения",
    awaitingApprovalDesc: "Ваш бизнес-аккаунт ожидает подтверждения. Вы получите уведомление после одобрения.",
    dashboard: "Бизнес-панель",
    yourOrders: "Ваши заказы",
    noOrders: "Заказов пока нет",
    orderNumber: "Номер заказа",
    orderDate: "Дата",
    status: "Статус",
    total: "Сумма",
    paymentStatus: "Статус оплаты",
    dueDate: "Срок оплаты",
    viewInvoice: "Смотреть счёт",
  },

  // Футер
  footer: {
    company: "Компания",
    about: "О нас",
    contact: "Контакты",
    careers: "Карьера",
    support: "Поддержка",
    faq: "ЧаВо",
    shipping: "Доставка",
    returnsPolicy: "Возврат",
    legal: "Юридическая информация",
    privacy: "Политика конфиденциальности",
    terms: "Условия использования",
    cookies: "Политика cookies",
    newsletter: "Рассылка",
    newsletterDesc: "Подпишитесь на новости и эксклюзивные предложения",
    subscribe: "Подписаться",
    emailPlaceholder: "Введите email",
    blog: "Блог",
    allRightsReserved: "Все права защищены",
    regNr: "Рег. №",
    vatNr: "НДС №",
    euSupportTitle: "Фонд восстановления ЕС",
    euSupportText: "Общество с ограниченной ответственностью \"Royal Bathrooms\", рег. № 40103384776, в рамках Фонда восстановления осуществляет инвестиции для улучшения коммерческих бизнес-процессов.",
    euSupportActivity: "Поддерживаемая деятельность: процессы продаж",
    euSupportSolution: "Решение: полноценное решение интернет-магазина для развития электронной коммерции компании.",
    purchaseTerms: "Условия покупки",
    workingHours: "Часы работы",
    workingHoursWeekdays: "Пн–Пт: 10:00–18:00",
    workingHoursSaturday: "Сб: 10:00–15:00",
    workingHoursSunday: "Вс: Закрыто",
  },

  purchaseTerms: {
    title: "Условия покупки",
    metaDescription: "Условия покупки в интернет-магазине HAUS — гарантия, возврат, цены, доставка.",
    lastUpdated: "Последнее обновление",
    warrantyTitle: "Гарантия",
    warrantyIntro: "На все товары, приобретённые в интернет-магазине www.haus.lv, предоставляется гарантия производителя. Минимальный гарантийный срок для физических лиц составляет 24 месяца в соответствии с нормативными актами Латвийской Республики. На отдельные товары производитель может установить более длительный гарантийный период. Для использования гарантии необходимо предъявить документ, подтверждающий покупку (счёт или накладную).",
    warrantyItem1: "Принадлежности и аксессуары товара (например, батарейки, лампочки и т.д.), если их износ является естественным.",
    warrantyItem2: "Детали, износ которых является нормальным результатом использования.",
    warrantyItem3: "Незначительные визуальные дефекты, не влияющие на функциональность товара.",
    warrantyExcludesTitle: "Гарантия не распространяется на:",
    warrantyExclude1: "Принадлежности и аксессуары товара (например, батарейки, лампочки и т.д.), если их износ является естественным.",
    warrantyExclude2: "Детали, износ которых является нормальным результатом использования.",
    warrantyExclude3: "Незначительные визуальные дефекты, не влияющие на функциональность товара.",
    warrantyVoidTitle: "Гарантия недействительна, если:",
    warrantyVoid1: "Товар механически повреждён или использован с нарушением инструкции по эксплуатации.",
    warrantyVoid2: "Выполнен несанкционированный ремонт.",
    warrantyVoid3: "Повреждения возникли в результате воздействия внешних факторов (влажность, перепады напряжения, пожар и т.д.).",
    warrantyVoid4: "Не соблюдены условия установки или эксплуатации.",
    warrantyLaw: "Гарантийные случаи рассматриваются в соответствии с нормативными актами Латвийской Республики.",
    withdrawalTitle: "Право на отказ",
    withdrawalItem1: "Покупатель (потребитель) имеет право отказаться от дистанционного договора в течение 14 дней со дня получения товара, не указывая причину.",
    withdrawalItem2: "Покупатель несёт ответственность за уменьшение стоимости товара, если товар использовался больше, чем необходимо для проверки его свойств и работы.",
    withdrawalItem3: "Товар должен быть возвращён в оригинальной комплектации.",
    withdrawalExcludesTitle: "Право на отказ не распространяется на:",
    withdrawalExclude1: "Товары, изготовленные по индивидуальному заказу.",
    withdrawalExclude2: "Товары, которые после доставки были необратимо смешаны с другими.",
    withdrawalExclude3: "Товары, которые по гигиеническим соображениям не подлежат возврату, если после доставки они были вскрыты.",
    withdrawalRefund: "Возврат денежных средств осуществляется в течение 14 дней после получения уведомления об отказе, но не ранее получения товара обратно.",
    pricingTitle: "Цены и наличие",
    pricingItem1: "Цены и наличие товаров в интернет-магазине могут быть изменены без предварительного уведомления.",
    pricingItem2: "Все цены указаны в евро (EUR) с включённым налогом на добавленную стоимость (НДС).",
    pricingItem3: "Для компаний Европейского Союза, являющихся плательщиками НДС и не находящихся в Латвии, может быть применена ставка НДС 0% в соответствии с нормативными актами.",
    privacyTitle: "Политика конфиденциальности",
    privacyText: "Информация, предоставленная клиентом, используется только для обработки заказов и обслуживания клиентов. Информация не передаётся третьим лицам, за исключением случаев, когда это необходимо для обеспечения доставки или предусмотрено нормативными актами.",
    privacyDataTitle: "Информация, необходимая для обработки заказа:",
    privacyData1: "Имя и фамилия",
    privacyData2: "Адрес доставки",
    privacyData3: "Контактный телефон",
    privacyData4: "Адрес электронной почты",
    privacyEmail: "Адрес электронной почты используется для подтверждения заказа и связи с клиентом. Рекламные сообщения отправляются только с согласия клиента.",
    passwordTitle: "Безопасность пароля",
    passwordText: "Пароли клиентов не хранятся в доступном виде. Восстановление пароля возможно с помощью функции «Забыл пароль».",
    deliveryTitle: "Условия доставки",
    deliveryItem1: "Если клиент недоступен во время доставки или не забирает отправление в установленный срок, повторная доставка может быть выполнена за дополнительную плату.",
    deliveryItem2: "Если покупатель отказывается от заказа после его отправки, продавец имеет право удержать стоимость доставки из возвращаемой суммы.",
    otherTitle: "Прочие условия",
    otherText: "Если заказанный товар недоступен из-за технических или складских ошибок, клиенту предлагается альтернативный товар или полный возврат оплаченной суммы.",
  },

  // Общее
  common: {
    loading: "Загрузка...",
    error: "Ошибка",
    close: "Закрыть",
    save: "Сохранить",
    cancel: "Отмена",
    confirm: "Подтвердить",
    yes: "Да",
    no: "Нет",
    or: "или",
  },

  // Секция О нас
  about: {
    tagline: "О HAUS",
    title: "Ваш партнёр в",
    titleAccent: "Дизайнерском совершенстве",
    paragraph1: "HAUS — это тщательно подобранная коллекция премиальной архитектурной фурнитуры, освещения и элементов интерьерного дизайна. Мы объединяем лучшие мировые бренды для взыскательных домовладельцев, архитекторов и дизайнеров интерьеров.",
    paragraph2: "Базируясь в Латвии, мы обслуживаем клиентов по всему Балтийскому региону и Европе, предлагая эксклюзивный доступ к брендам, таким как Buster + Punch и другим премиальным производителям.",
    paragraph3: "Каждый продукт в нашей коллекции тщательно отобран за исключительное мастерство, инновационный дизайн и непреходящее качество. Мы верим, что детали важны — от выключателя на стене до ручки на двери.",
  },

  // Секция Buster + Punch
  busterPunch: {
    exclusivePartner: "ЭКСКЛЮЗИВНЫЙ ПАРТНЁР",
    brandDescription: "Лондонский бренд, создающий изысканную фурнитуру, освещение и интерьерные детали из массивного металла с неповторимым характером и стилем.",
    theStory: "ИСТОРИЯ",
    mastersOfMetal: "Мастера металла с 2013 года",
    storyParagraph1: "Buster + Punch был основан в 2013 году архитектором Массимо Бастер Минале с целью создания лучших в мире интерьерных деталей из массивного металла. Сегодня, вдохновлённые культурными течениями Лондона, коллекции Buster + Punch преображают дома и пространства по всему миру.",
    storyParagraph2: "Для профессионалов отрасли бренд является бесспорным мастером металла, создающим изысканные функциональные изделия, которые не только возвышают пространства, но и пробуждают страсть и индивидуальность. Бескомпромиссное внимание к деталям и использование премиального массивного металла поставили интерьерные детали Buster + Punch в один ряд с авторской мебелью.",
    storyParagraph3: "С эстетикой и идентичностью бренда, схожими с культовыми домами высокой моды, Buster + Punch — это отношение и стиль жизни для своих последователей. Коллаборации объединяют дизайн с модой, музыкой, искусством и культурой.",
    storyHighlight: "Первые, кто привнёс прецизионную накатку в интерьерную фурнитуру. Имя, ставшее синонимом выключателей и розеток из массивного металла. Первый бренд в мире, выпустивший дизайнерскую LED-лампу в 2015 году.",
    discoverCollection: "Откройте полную коллекцию",
    discoverCollectionDesc: "Исследуйте полный ассортимент продукции Buster + Punch, доступный через HAUS",
    shopBusterPunch: "МАГАЗИН BUSTER + PUNCH",
    founderQuote1: "Я горжусь тем, что мы были первыми, кто вдохнул жизнь в функциональные детали дома через нашу страсть к металлам. Наша оригинальность, уникальный взгляд и подход проложили новые пути в интерьерах за десятилетие.",
    founderQuote2: "Как бренд, мы всегда принимали перемены. Сегодня наш мир кардинально отличается от наших скромных гаражных начинаний. Тогда вдохновение расцветало в трещинах лондонских тротуаров, а теперь наши небоскрёбы возвышаются, и социальные сети стремятся изолировать нас от улиц, по которым мы когда-то ходили. Эти перемены — возможности открыть новые источники вдохновения, таланты и техники, оставаясь верными своим корням.",
    founderQuote3: "Как бренд, мы обязуемся быть более ответственными и гарантировать, что наши продукты останутся значимыми и уникальными. Мы останемся аналоговыми и тактильными, глядя в будущее — соединяя традиции с технологиями для создания новых глав. Расширяя границы индустрии и черпая вдохновение из субкультур нашего города, мы обещаем ставить наших людей, клиентов и сообщество в центр нашего мира.",
    founderName: "МАССИМО БАСТЕР МИНАЛЕ",
    founderRole: "Основатель и креативный директор",
    // Коллекция Electricity
    electricityTitle: "Коллекция Electricity",
    electricitySubtitle: "ЕВРОПЕЙСКАЯ ЛИНЕЙКА",
    electricityDesc: "Востребованная коллекция ELECTRICITY от Buster + Punch теперь доступна в европейской версии. Обширный ассортимент выключателей, диммеров, розеток, которые буквально меняют ваше восприятие домашних деталей одним щелчком.\n\nРазработанная в Лондоне и вдохновлённая микшерными пультами и усилителями, линейка изготовлена из массивных драгоценных металлов, накатана на ЧПУ-станках с алмазными наконечниками и точно доработана вручную.\n\nELECTRICITY — это продукт философии Buster + Punch: превращать «обычные» продукты, дизайны и детали в необыкновенный опыт. Как линейка, они открывают новый способ проектирования с деталями, связывая комнаты и пространства тактильной красной нитью.\n\nКоллекция доступна в полных комплектах или модульных наборах с 11 различными комбинациями. Выбирайте из стали, латуни, копчёной бронзы, чёрного и белого. Линейка также включает «ретрактивные выключатели» для систем умного дома.",
    electricityQuote: "Мы всегда чувствовали, что не хватает красоты и ощущений в интерьерных деталях, когда речь идёт об этих предметах. Это необходимые элементы, но трудно понять, почему никто раньше не вложил в них заботу и страсть. В других областях нашей жизни выключателям и ручкам уделяют красивый дизайн — автомобили, например, или гитарные усилители, даже пульты управления.",
    // Серия Linear
    linearTitle: "Серия Linear — Выключатели, диммеры и розетки",
    linearSubtitle: "ИКОНЫ В НОВОМ ОБЛИКЕ",
    linearDesc: "Buster + Punch возвращается к микшерному пульту этим летом, чтобы переработать свои культовые переключатели, диммеры и розетки из массивного металла — на этот раз с прецизионной линейной накаткой бренда как главной эстетикой. Черпая вдохновение из классических аналоговых усилителей и мира швейцарского часового дела, эти обязательные интерьерные детали были переосмыслены с тщательным вниманием к деталям.\n\nВыключатели, диммеры и розетки Buster + Punch из массивного металла с прецизионной накаткой — одни из самых востребованных интерьерных деталей в мире. Любимые звёздами, дизайнерами, архитекторами и законодателями вкуса, их премиальные материалы и безошибочное аналоговое действие покоряют каждого, кто с ними взаимодействует.\n\nНовые выключатели, диммеры и розетки завершают серию Linear и расширяют линейку с идеальной преемственностью. Коллекция присоединяется к комплексному интерьерному ассортименту Buster + Punch, позволяя провести стиль Linear через всю фурнитуру, освещение, аксессуары и теперь электрику вашего дома.\n\nДоступны в отделке из массивного металла: белый, сталь, латунь, копчёная бронза и чёрный. Полностью сертифицированы для ЕС, Северной Америки, Великобритании, Австралии и Новой Зеландии.",
    // Кран кипящей воды
    boilingTapTitle: "Кран мгновенного кипятка",
    boilingTapSubtitle: "КУХОННЫЕ ИННОВАЦИИ",
    boilingTapDesc: "Новый кран мгновенного кипятка от Buster + Punch приносит удобство охлаждённой фильтрованной воды и мгновенного кипятка на кухню, сочетая это с фирменной эстетикой и характером бренда.\n\nРазработанный совместно с одним из ведущих европейских производителей смесителей, кран спроектирован с нуля, используя опыт Buster + Punch в работе с массивными металлами. С грубо литой металлической основой, изолированной шейкой из шлифованного металла, крестовым или линейным накатанным рычагом из массивного металла, а также соответствующей накатанной крышкой аэратора и переключателем функций.\n\nОдним простым движением накатанного переключателя вы можете налить идеальный стакан фильтрованной холодной воды, приготовить горячий напиток или ускорить готовку с мгновенной водой 98 градусов. Кран оснащён полностью настраиваемыми параметрами и функциями предотвращения случайной активации горячей воды.\n\nУникальная эстетика крана Buster + Punch дополняет фирменную линейку кухонной фурнитуры, создавая безупречную гармонию во всём кухонном пространстве.",
    // Кухня
    kitchenTitle: "Кухня Buster + Punch",
    kitchenSubtitle: "МОДУЛЬНЫЙ ОТДЕЛЬНОСТОЯЩИЙ ДИЗАЙН",
    kitchenDesc: "Прошли времена встроенных кухонь с коротким сроком службы и ограниченной гибкостью. Кухня Buster + Punch — это новый способ создать индивидуальную, модульную, отдельностоящую кухню.\n\nНастраиваемая онлайн и изготовленная с точностью и инженерией прославленной фурнитуры из массивного металла, кухня несёт уровень эстетики и качества, который вы ожидаете от авторской мебели.\n\nВдохновлённая профессиональной отдельностоящей кухней шеф-повара, дизайн сводит к минимуму элементы модульных блоков. Кухня собирается из двух вариантов рамы, трёх цветов шкафов и трёх столешниц, спроектированных вокруг бесконечного выбора культовой фурнитуры бренда — украшений кухни Buster + Punch.\n\nКухонные модули имеют столешницу от края до края из камня или металла с уникальным радиусом угла, соответствующим экструдированной металлической раме. Сама рама имеет прецизионно литые алюминиевые ножки, опирающиеся на изготовленные на заказ точёные регулируемые ножки из латуни или нержавеющей стали, отделанные фирменной алмазной накаткой бренда.",
    kitchenQuote: "Мы хотели перевернуть условности кухонного дизайна, используя фурнитуру и детали как отправную точку всего процесса. В результате получилась кухня, которая адаптируема, удобна и выглядит так, будто выточена из цельного куска металла и камня.",
  },

  // Страница бренда
  brandPage: {
    founded: "Основан",
    origin: "Происхождение",
    website: "Сайт",
    catalog: "Каталог",
    busterPunchDescription: "Buster + Punch — это лондонский интерьерный бренд с миссией изменить детали в домах и коммерческих пространствах по всему миру. Основанный в 2013 году Массимо Минале, бренд создаёт необыкновенные изделия для повседневного использования — от выключателей и дверной фурнитуры до освещения и авторских кухонь. Каждое изделие спроектировано в Лондоне и изготовлено из массивных высококачественных металлов с акцентом на мастерство и премиальную отделку.",
    deanteDescription: "Deante — ведущий европейский производитель оборудования для ванных комнат и кухонь. С современным дизайном, функциональностью и высокими стандартами Deante уделяет особое внимание качеству и безопасности своей продукции. Откройте для себя мойки и смесители, которые преобразят вашу кухню. Комплексное оборудование для ванных комнат позволяет создать пространство, идеальное для ежедневных ритуалов ухода. Высококачественные продукты и инновационные решения превращают каждый момент в ванной комнате в настоящее удовольствие.",
    karrayDescription: "K-Array — итальянская аудиокомпания, специализирующаяся на ультратонких высокопроизводительных акустических системах. Основанная в 1990 году, она создаёт инновационные решения для профессиональных аудиоприложений — от концертов и мероприятий до архитектурных инсталляций. Их колонки спроектированы так, чтобы быть практически невидимыми, обеспечивая при этом исключительное качество звука.",
    victoriaAlbertDescription: "Victoria + Albert Baths — британский бренд с мировой репутацией в создании роскошных отдельностоящих ванн и раковин. Основанная в 1996 году со страстью к ваннам и купанию, компания имеет головной офис в Великобритании и производственные мощности в Южной Африке. Сегодня международные корни Victoria + Albert объединяют глобальный дизайн, продажи и маркетинговые операции с собственным производством для создания роскошных, долговечных продуктов. Как высшее заявление о качестве и стиле, наш модельный ряд наполнен вдохновляющими отдельностоящими дизайнами из 100% QUARRYCAST™ — смеси вулканического известняка и высокоэффективных смол. Натурально белые, каждое изделие индивидуально обрабатывается мастерами вручную.",
    nokenDescription: "Noken — премиальный бренд для ванных комнат из группы PORCELANOSA, специализирующийся на инновационных решениях для ванных комнат. С акцентом на передовой дизайн и экологичность, Noken предлагает отдельностоящие ванны, раковины, смесители и душевые системы, сочетающие элегантность с передовыми технологиями.",
    teceDescription: "TECE — немецкий производитель премиальных санитарных инсталляционных систем. Основанная в 1955 году, TECE специализируется на смывных панелях для унитазов, душевых трапах, бачках и инсталляционных системах. Известные своим инновационным дизайном и инженерным совершенством, продукты TECE сочетают функциональность с современной эстетикой.",
    tresDescription: "TRES — испанский производитель премиальных смесителей для ванных комнат и кухонь. Основанная в 1947 году, TRES сочетает более 75 лет опыта с передовыми технологиями для создания инновационных решений в области смесителей. Известные исключительным качеством, современным дизайном и широким ассортиментом эксклюзивных покрытий, включая 24K золото и матовое розовое золото, продукты TRES привносят роскошь и функциональность в каждое пространство.",
    decorWaltherDescription: "Decor Walther — немецкий производитель премиальных аксессуаров для ванных комнат и зеркал. Основанная в 1973 году, марка олицетворяет вневременную элегантность, выдающееся мастерство и высочайшие стандарты качества. От зеркал с подсветкой и дозаторов мыла до полотенцедержателей и полок — каждый продукт Decor Walther создан, чтобы превратить ванную комнату в роскошное убежище.",
    excellentDescription: "Excellent — польский производитель, специализирующийся на премиальных решениях для ванных комнат, включая душевые ограждения, поддоны, ванны и раковины. Известный инновационными стекольными технологиями и современным дизайном, продукция Excellent сочетает функциональность с современной эстетикой для создания красивых ванных комнат.",
  },

  // Секция брендов
  brands: {
    tagline: "Эксклюзивные партнёры",
    title: "Наши бренды",
  },

  // Уведомление о куки
  cookies: {
    bannerText: "Мы используем файлы cookie для улучшения вашего опыта просмотра, предоставления персонализированного контента и анализа трафика. Нажимая \"Принять все\", вы соглашаетесь на использование файлов cookie.",
    learnMore: "Узнать больше",
    acceptAll: "Принять все",
    declineOptional: "Только необходимые",
  },

  // Страница политики куки
  cookiesPolicy: {
    title: "Политика использования файлов cookie",
    lastUpdated: "Последнее обновление",
    whatAreCookiesTitle: "Что такое файлы cookie?",
    whatAreCookiesText: "Файлы cookie — это небольшие текстовые файлы, которые сохраняются на вашем устройстве (компьютере, планшете или мобильном телефоне) при посещении веб-сайта. Они широко используются для обеспечения более эффективной работы веб-сайтов, улучшения пользовательского опыта и предоставления информации владельцам сайтов.",
    howWeUseTitle: "Как мы используем файлы cookie",
    howWeUseText: "SIA \"Royal Bathrooms\" (регистрационный номер 40103384776, номер НДС LV40103384776), работающая под брендом HAUS, использует файлы cookie на этом веб-сайте в целях, описанных ниже. Используя наш сайт, вы соглашаетесь на использование файлов cookie в соответствии с данной политикой и Общим регламентом защиты данных ЕС (GDPR), реализованным в законодательстве Латвии.",
    essentialTitle: "Необходимые файлы cookie",
    essentialText: "Эти файлы cookie строго необходимы для правильной работы веб-сайта. Они обеспечивают основную функциональность, такую как безопасность, управление сетью и доступность. Вы не можете отказаться от этих файлов cookie, так как без них сайт не может функционировать.",
    essentialItem1: "Управление сессией — поддержание авторизации во время посещения",
    essentialItem2: "Настройки согласия на cookie (cookie-consent) — запоминание ваших предпочтений, хранится в localStorage",
    essentialItem3: "Корзина покупок — сохранение содержимого корзины при просмотре",
    analyticsTitle: "Аналитические файлы cookie (Google Analytics 4)",
    analyticsText: "Мы используем Google Analytics 4 (GA4, идентификатор: G-6J439RCQ4P) для понимания взаимодействия посетителей с нашим сайтом. Эти файлы cookie активируются только после вашего явного согласия через баннер cookie. GA4 устанавливает следующие cookie: _ga (срок: 2 года, для различения пользователей), _ga_* (срок: 2 года, для поддержания состояния сессии). Все собранные данные агрегированы и анонимны. Данные Google Analytics могут обрабатываться на серверах за пределами Европейской экономической зоны (ЕЭЗ), включая США. Google участвует в рамочной программе ЕС-США по защите данных. Если вы не дадите согласие, аналитические данные не будут собираться.",
    marketingTitle: "Маркетинговые файлы cookie (Meta Pixel)",
    marketingText: "Мы используем Meta Pixel (Facebook Pixel, ID: 3229144413891730) для измерения эффективности рекламы и показа релевантной рекламы. Meta Pixel устанавливает следующие cookie: _fbp (срок: 3 месяца, для доставки и измерения рекламы), fr (срок: 3 месяца, для таргетинга рекламы). Данные Meta Pixel могут передаваться на серверы в США. Meta участвует в рамочной программе ЕС-США по защите данных. Эти cookie используются для ремаркетинга и анализа аудитории.",
    thirdPartyTitle: "Файлы cookie третьих сторон",
    thirdPartyText: "Некоторые файлы cookie размещаются сторонними сервисами на наших страницах. Мы используем сторонние сервисы, такие как Shopify (для функциональности электронной коммерции) и встроенный контент. Эти третьи стороны могут устанавливать свои собственные файлы cookie в соответствии со своими политиками конфиденциальности. Мы не контролируем файлы cookie третьих сторон.",
    dataTransferTitle: "Международная передача данных",
    dataTransferText: "Некоторые из используемых нами сторонних сервисов (Google, Meta) могут обрабатывать данные за пределами Европейской экономической зоны (ЕЭЗ). Эти передачи защищены рамочной программой ЕС-США по защите данных и/или Стандартными договорными положениями, утверждёнными Европейской комиссией, в соответствии со статьёй 46 GDPR.",
    managingTitle: "Управление файлами cookie",
    managingText: "Вы можете управлять настройками cookie через наш баннер согласия при первом посещении сайта. Вы также можете контролировать cookie через настройки браузера. Большинство браузеров позволяют отклонять или принимать cookie, удалять существующие и устанавливать предпочтения для определённых сайтов. Обратите внимание, что отключение необходимых cookie может повлиять на функциональность сайта. Вы можете в любое время отозвать согласие, очистив cookie браузера и повторно посетив сайт — баннер согласия появится снова.",
    yourRightsTitle: "Ваши права по GDPR",
    yourRightsText: "В соответствии с Общим регламентом защиты данных (GDPR) и латвийским законодательством о защите данных вы имеете право: получить доступ к своим персональным данным, запросить исправление или удаление данных, ограничить обработку данных или возразить против неё, на переносимость данных, а также подать жалобу в Государственную инспекцию данных Латвии (Datu valsts inspekcija, www.dvi.gov.lv). Для реализации этих прав свяжитесь с нами по контактам ниже.",
    changesTitle: "Изменения в данной политике",
    changesText: "Мы можем время от времени обновлять данную политику для отражения изменений в технологиях, законодательстве или нашей практике обработки данных. Все изменения будут опубликованы на этой странице с обновлённой датой редакции. Мы рекомендуем периодически просматривать эту политику.",
    contactTitle: "Свяжитесь с нами",
    contactText: "Если у вас есть вопросы об использовании cookie, данной политике или вы хотите воспользоваться своими правами на защиту данных, свяжитесь с нами:",
  },

  // Страница политики конфиденциальности
  privacyPolicy: {
    seoTitle: "Политика конфиденциальности | HAUS",
    seoDescription: "Узнайте, как HAUS собирает, использует и защищает ваши персональные данные в соответствии с GDPR и латвийским законодательством о защите данных.",
    title: "Политика конфиденциальности",
    lastUpdated: "Последнее обновление",
    introTitle: "Введение",
    introText: "Настоящая Политика конфиденциальности объясняет, как SIA \"Royal Bathrooms\", работающая под брендом HAUS, собирает, использует, хранит и защищает ваши персональные данные при использовании нашего сайта www.haus.lv и наших услуг. Мы стремимся защищать вашу конфиденциальность в соответствии с Общим регламентом защиты данных ЕС (GDPR) и латвийским Законом об обработке персональных данных.",
    controllerTitle: "Контролёр данных",
    controllerText: "Контролёром данных, ответственным за ваши персональные данные, является:",
    controllerName: "SIA \"Royal Bathrooms\"",
    controllerRegNr: "Рег. №: 40103384776",
    controllerAddress: "Адрес: Cēsu iela 31 k-3, Rīga, LV-1012, Латвия",
    controllerEmail: "Эл. почта: haus@royal-bathrooms.com",
    controllerPhone: "Телефон: +371 6737 6780",
    dataWeCollectTitle: "Какие данные мы собираем",
    dataWeCollectIntro: "Мы собираем различные типы персональных данных в зависимости от того, как вы взаимодействуете с нашим сайтом:",
    orderDataTitle: "Данные заказов и клиентов",
    orderDataText: "При оформлении заказа или создании учётной записи мы собираем:",
    orderDataItem1: "Имя и фамилия",
    orderDataItem2: "Адрес электронной почты",
    orderDataItem3: "Номер телефона",
    orderDataItem4: "Адрес доставки и выставления счетов",
    orderDataItem5: "История заказов и платёжная информация (безопасно обрабатывается Shopify Payments)",
    businessDataTitle: "Данные бизнес-клиентов",
    businessDataText: "Для бизнес-клиентов мы дополнительно собираем: название компании, регистрационный номер, номер НДС, данные уполномоченного контактного лица и адреса для выставления счетов/доставки.",
    technicalDataTitle: "Технические и аналитические данные",
    technicalDataText: "При просмотре нашего сайта мы можем собирать: IP-адрес (анонимизированный), тип и версию браузера, информацию об устройстве, посещённые страницы и данные о взаимодействии — только с вашего согласия через файлы cookie (см. нашу Политику cookie).",
    legalBasisTitle: "Правовое основание обработки",
    legalBasisText: "Мы обрабатываем ваши персональные данные на следующих правовых основаниях в соответствии со статьёй 6 GDPR:",
    legalBasisItem1: "Исполнение договора — обработка, необходимая для выполнения вашего заказа или предоставления наших услуг (ст. 6(1)(b))",
    legalBasisItem2: "Юридическое обязательство — обработка, требуемая латвийским налоговым, бухгалтерским или коммерческим законодательством (ст. 6(1)(c))",
    legalBasisItem3: "Согласие — для аналитических cookie и маркетинговых коммуникаций, которое вы можете отозвать в любое время (ст. 6(1)(a))",
    legalBasisItem4: "Законный интерес — для безопасности сайта, предотвращения мошенничества и улучшения наших услуг (ст. 6(1)(f))",
    purposeTitle: "Цели обработки данных",
    purposeItem1: "Обработка и выполнение ваших заказов, включая доставку и выставление счетов",
    purposeItem2: "Управление вашей учётной записью и предоставление клиентской поддержки",
    purposeItem3: "Соблюдение юридических и налоговых обязательств по латвийскому законодательству",
    purposeItem4: "Анализ использования сайта для улучшения наших услуг (с вашего согласия)",
    purposeItem5: "Отправка маркетинговых сообщений (только с вашего явного согласия)",
    sharingTitle: "Передача данных",
    sharingText: "Мы можем передавать ваши персональные данные следующим категориям получателей, только в необходимом объёме:",
    sharingItem1: "Shopify Inc. — наш провайдер платформы электронной коммерции, обрабатывающий данные заказов и платежей",
    sharingItem2: "Службы доставки — для выполнения ваших заказов",
    sharingItem3: "Google LLC — для аналитики сайта (Google Analytics 4), только с вашего согласия",
    sharingItem4: "Meta Platforms Inc. — для измерения эффективности рекламы (Meta Pixel), только с вашего согласия",
    transferTitle: "Международная передача данных",
    transferText: "Некоторые из наших поставщиков услуг (Shopify, Google, Meta) могут обрабатывать данные за пределами Европейской экономической зоны (ЕЭЗ), включая США и Канаду. Эти передачи защищены рамочной программой ЕС-США по защите данных, Стандартными договорными положениями, утверждёнными Европейской комиссией, и/или решениями об адекватности в соответствии со статьями 45-46 GDPR.",
    retentionTitle: "Срок хранения данных",
    retentionText: "Мы храним ваши персональные данные только столько, сколько необходимо для целей, описанных в этой политике. Данные заказов хранятся 5 лет после транзакции, как требует латвийское налоговое и бухгалтерское законодательство (закон \"О бухгалтерском учёте\"). Данные учётной записи хранятся до вашего запроса на удаление. Аналитические данные анонимизированы и агрегированы. Вы можете запросить удаление данных в любое время с учётом юридических требований к хранению.",
    rightsTitle: "Ваши права",
    rightsText: "В соответствии с GDPR и латвийским законодательством о защите данных вы имеете следующие права в отношении ваших персональных данных:",
    rightsItem1: "Право на доступ — получить копию обрабатываемых нами персональных данных",
    rightsItem2: "Право на исправление — исправить неточные или неполные данные",
    rightsItem3: "Право на удаление — запросить удаление ваших данных (\"право быть забытым\")",
    rightsItem4: "Право на ограничение — ограничить способ обработки ваших данных",
    rightsItem5: "Право на переносимость — получить данные в структурированном, машиночитаемом формате",
    rightsItem6: "Право на возражение — возразить против обработки на основе законного интереса или прямого маркетинга",
    rightsComplaint: "Вы также имеете право подать жалобу в Государственную инспекцию данных Латвии (Datu valsts inspekcija): www.dvi.gov.lv, эл. почта: info@dvi.gov.lv, адрес: Elijas iela 17, Rīga, LV-1050.",
    securityTitle: "Безопасность данных",
    securityText: "Мы применяем соответствующие технические и организационные меры для защиты ваших персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения. Наш сайт использует шифрование SSL/TLS для всей передачи данных. Доступ к персональным данным ограничен только уполномоченным персоналом.",
    changesTitle: "Изменения в данной политике",
    changesText: "Мы можем время от времени обновлять данную Политику конфиденциальности для отражения изменений в нашей практике, технологиях или юридических требованиях. Все изменения будут опубликованы на этой странице с обновлённой датой редакции. Мы рекомендуем периодически просматривать эту политику.",
    contactTitle: "Свяжитесь с нами",
    contactText: "Если у вас есть вопросы о данной Политике конфиденциальности, вы хотите воспользоваться своими правами на защиту данных или у вас есть вопросы о том, как мы обрабатываем ваши персональные данные, свяжитесь с нами:",
  },
};
